import { PropsWithChildren } from 'react';
import Page, { PageProps } from '../page/Page';

interface StandardPageProps extends Omit<PageProps, 'nav'> {}

const StandardPage = ({
  children,
  header,
  fullWidth = true,
}: PropsWithChildren<StandardPageProps>) => {
  return (
    <Page header={header} fullWidth={fullWidth}>
      {children}
    </Page>
  );
};

export default StandardPage;
